import React from 'react';
import LoadingBase from '../Loading';

const Loading = () => {
  return (
    <div
      className="fixed left-0 right-0 top-0 bottom-0 z-[10000] flex items-center justify-center bg-tint-white-700"
      style={{ transform: 'translateZ(100px)' }}>
      <LoadingBase />
    </div>
  );
};

export default Loading;
